import { render, staticRenderFns } from "./GroupPreferences.vue?vue&type=template&id=537fbc6c&"
import script from "./GroupPreferences.vue?vue&type=script&lang=ts&"
export * from "./GroupPreferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports